import { Satisfaction } from 'lib-shared-legacy-types';
import * as React from 'react';

import { EmailPreview } from '../EmailPreview';

import style from './index.module.scss';

interface Props {
  subjectText: string;
  emailBodyText: string;
  ratingQuestion: string;
  ratingStyle: Satisfaction.RatingStyle;
}

export const EmailPreviewSection: React.FunctionComponent<Props> = (props) => {
  return (
    <section className={style.root}>
      <header className={style.header}>Email preview</header>

      <div className={style.subHeader}>
        <p>This is a preview of the CSAT survey sent to the user.</p>
        <p>
          To ensure surveys are threaded with the conversation in the
          user&apos;s email client, keep &quot;Re:{' '}
          {'{{ conversation_subject }}'}&quot; as the Email subject line of your
          CSAT surveys. Changing this will undo that logic. Same thread is
          generally recommended for more consistent responses.
        </p>
      </div>

      <EmailPreview
        ratingStyle={props.ratingStyle}
        subjectText={props.subjectText}
        emailBodyText={props.emailBodyText}
        ratingQuestion={props.ratingQuestion}
      />
    </section>
  );
};
